export default "__VITE_ASSET__25f07b03__"